let _get = null;
let _post = null;

export default function ActConfApi($get, $post) {
  _get = $get;
  _post = $post;
}

function getMiddleware(url, params, type = 'act') {
  if (_get) {
    return _get('/center/activity/', {
      [type]: url,
      ...params,
    });
  } else {
    return console.warn('function _get is undefined!');
  }
}

function postMiddleware(url, params, type = 'act') {
  if (_post) {
    return _post(`/center/activity/?${type}=${url}`, {
      ...params,
    });
  } else {
    return console.warn('function _post is undefined!');
  }
}

export const actConfApi = {
  getMapsByUin: params => getMiddleware('get_map_by_uin', params),
  getArticleInfo: params => getMiddleware('article_info', params),
  getArticleByUin: params => getMiddleware('article_list_by_uin', params),
  getActivityList: params => getMiddleware('activity_list', params),
  postArticle: params => postMiddleware('add_article', params),
  updateArticle: params => postMiddleware('edit_article', params),
  updateActivity: params => getMiddleware('edit_activity', params),
  addActivity: params => getMiddleware('add_activity', params),
  updateArticleState: params => getMiddleware('article_state', params),
  // 地图动态相关
  trendRelated: params => postMiddleware('add_related_posting', params),
  updateTrendRelated: params => postMiddleware('edit_related_posting', params),
  updateTrendRelatedState: params =>
    getMiddleware('related_posting_state', params),
  getTrendRelatedListByUin: params =>
    getMiddleware('related_posting_list_by_uin', params),
  getTrendRelatedListByMapId: params =>
    getMiddleware('related_posting_list_by_map_id', params),
  getTrendRelatedInfo: params => getMiddleware('related_posting_info', params),
};
